import Vue from 'vue'
import VueRouter from 'vue-router'
import initProgress from 'src/progressbar'
import store from 'src/store/'

import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'

// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue'

// Dashboard pages
const Overview = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Overview.vue')

// Charts pages
const Charts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Charts.vue')

// Inventory pages
const Inventory = () => import(/* webpackChunkName: "inventory" */  'src/components/Dashboard/Views/Inventory/Inventory.vue')

// Report pages
const Report = () => import(/* webpackChunkName: "inventory" */  'src/components/Dashboard/Views/Report/Report.vue')

// Import pages
const UpdateStatus = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Import/UpdateStatus.vue')
const UpdateBagNo = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Import/UpdateBagNo.vue')

const CustomersIndex = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Customers/Index.vue')
const CustomerEdit = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Customers/FormEdit.vue')

const ManifestIndex = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Manifest/Index.vue')
const ManifestEdit = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Manifest/FormEdit.vue')

const Logging = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Logging/Index.vue')


import Login from 'src/components/Dashboard/Views/Pages/Login.vue'

Vue.use(VueRouter)

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let pages = {
  path: '/',
  component: DashboardLayout,
  redirect: '/overview',
  children: [
    {
      path: 'overview',
      name: 'Overview',
      component: Overview
    },
    {
      path: 'charts',
      name: 'Charts',
      component: Charts
    },
    {
      path: 'inventory',
      name: 'Inventory',
      component: Inventory
    },
    {
      path: 'report',
      name: 'Report',
      component: Report
    },
    {
      path: 'import/update_status',
      name: 'UpdateStatus',
      component: UpdateStatus
    },
    {
      path: 'import/update_bagno',
      name: 'UpdateBagNo',
      component: UpdateBagNo
    },
    
    {
      path: 'logging',
      name: 'Logging',
      component: Logging
    }
  ],
  meta: {
    requiresAuth: true
  }
}

let customerPage = {
  path: '/customers',
  name: 'Customers',
  component: DashboardLayout,
  redirect: '/customers',
  children: [
    {
      path: '',
      name: 'CustomersIndex',
      component: CustomersIndex
    },
    {
      path: ':id',
      name: 'CustomerEdit',
      component: CustomerEdit
    },
  ],
  meta: {
    requiresAuth: true
  }
}

let manifestPage = {
  path: '/manifest',
  name: 'manifest',
  component: DashboardLayout,
  redirect: '/manifest',
  children: [
    {
      path: '',
      name: 'ManifestIndex',
      component: ManifestIndex
    },
    {
      path: ':id',
      name: 'ManifestEdit',
      component: ManifestEdit
    },
  ],
  meta: {
    requiresAuth: true
  }
}



const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/overview'
  },
  loginPage,
  pages,
  customerPage,
  manifestPage,
  {path: '*', component: NotFound}
];

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

initProgress(router);

router.beforeEach((to, from, next) => {
  const publicPages = ['/login'];
  const authRequired = publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('token');

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    if (!loggedIn) {
      next({ path: '/login' })
    } else {
      if (authRequired) {
        next({ path: '/overview' })
      } else {
        next()
      }
    }
  } else {
    if (authRequired && loggedIn) {
      next({ path: '/overview' })
    } else {
      next()
    }
  }
})

export default router
